import gql from "graphql-tag";

export const GET_FRENCH_ITEMS =  gql`
  
    query getFrenchItemList($id: ID!) {
        getFrenchItemList(id: $id) {
            id
            metaDataValueId
	        entityId
	        entity
	        fieldName
	        fieldValueEn
	        fieldValueFr
	        fieldValueMaxLen
            fieldValueTranslated
            fieldName2
            fieldValue2En
            fieldValue2Fr
            fieldValue2Translated
            updatedBy
            dateUpdated
        }
    }
`;

export const GET_FRENCH_ITEM_DETAIL =  gql`
  
    query getFrenchItemDetail($id: ID!, $input: FrenchTaskInfoInput) {
        getFrenchItemDetail(id: $id, input: $input) {
            name
	        orgId
	        orgName
	        positionId
	        positionName
	        individualId
	        individualName
	        bizGroupId
	        bizGroupName
            suggested
        }
    }
`;

export const UPDATE_FRENCH_TRANS = gql `
mutation updateFrenchTranslation($input:FrenchTransUpdateInput!){
    updateFrenchTranslation(input:$input)
   
}`;
